module.exports = __webpack_public_path__ + "static/media/homepagebanner.0b4d1b85.jpg";